import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../icon";
export default function Navigation2(props) {
    return (_jsx(Icon, { ...props, children: _jsx("path", { d: "M12 1a1 1 0 0 1 .938.654l7 19a1 1 0 0 1-1.434 1.214L12 18.152l-6.504 3.716a1 1 0 0 1-1.434-1.214l7-19A1 1 0 0 1 12 1ZM6.887 18.77l4.617-2.638a1 1 0 0 1 .992 0l4.617 2.638L12 4.893 6.887 18.77Z" }) }));
}
